<template>
  <div class="delivery-map-1 col-12" v-if="Object.keys(deliveryRange).length > 0">
    <div id="mapContainer"></div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import markerIcon from "./map_icon.png";

export default {
  name: "DeliveryMap1",
  props: {
    coordinate: {
      default: null
    }
  },
  data() {
    return {
      map: null,
      deliveryRange: {},
      zoom: 6, // Zoom level for the map
      center: [32.4279, 53.6880], // Coordinates of Iran
      markerPosition: [32.4279, 53.6880], // Marker coordinates
      markerCoordinates: null, // To store the marker coordinates as a string
      customIcon: new L.Icon({
        iconUrl: markerIcon, // Path to your custom marker icon
        iconSize: [50, 50], // Size of the icon
        iconAnchor: [16, 32], // Point of the icon that will correspond to the marker's location
        popupAnchor: [0, -32], // Position of the popup
      }),
      tileLayerUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", // Tile layer URL
      attribution: "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors", // Attribution text
    };
  },
  methods: {
    async getDeliveryStoreConfig() {
      let req = await this.$store.dispatch('Delivery/getDeliveryBaseOnLocationConfig')
      let data = req.data.data
      if (Array.isArray(data)) {
        toast('تنظیمات فروشگاه مشخص نشده است.', 'تنظیمات فروشگاه مشخص نشده است.', 'danger')
        return false
      }


      data = JSON.parse(data.value)
      this.markerPosition = data.store_location.split(',')
      this.center = data.store_location.split(',')

      this.deliveryRange = data

    },
    onMapClick(event) {
      const latLng = event.latlng;
      this.markerPosition = [latLng.lat, latLng.lng]; // موقعیت جدید را تنظیم می‌کنیم
      this.$emit("location", this.markerPosition);
      localStorage.setItem("order_delivery", this.markerPosition);

      // حذف مارکر قبلی
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      // افزودن مارکر جدید
      this.marker = L.marker(this.markerPosition, {icon: this.customIcon}).addTo(this.map);

    },
    setDefaultCoordinate() {
      let data = this.coordinate.split(',')
      let event = {
        latlng: {
          lat: data[0],
          lng: data[1],
        }
      }
      this.onMapClick(event)
      this.map.setView(this.markerPosition, this.map.getZoom());
    }
  },
  async mounted() {
    await this.getDeliveryStoreConfig()

    this.map = L.map("mapContainer").setView(this.center, 20);
    L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);

    this.marker = L.marker(this.markerPosition, {icon: this.customIcon}).addTo(this.map);

    this.map.on("click", (event) => {
      this.onMapClick(event)
    });

    this.map.on("zoomend", () => {
      this.marker.setLatLng(this.markerPosition);
    });

  },
  onBeforeUnmount() {
    if (this.map) {
      this.map.remove();
    }
  },
  watch: {
    coordinate: {
      handler(val, oldVal) {
        if(this.map != null){
          this.setDefaultCoordinate()
        }
      },
      deep: true,
    },
  }

}
</script>

<style scoped>
.delivery-map-1 {
  height: 350px;
}

#mapContainer {
  width: 100%;
  height: 350px;
}
</style>